import { parse } from 'qs';
import { useContext, useEffect, useState } from 'react';

import { context as stateContext } from '../view/context/state';

export const useGetOrganizationId = () => {
  const { location } = useContext(stateContext);
  const [organizationId, setOrganizationId] = useState('');

  useEffect(() => {
    setOrganizationId(parse(location.search.slice(1)).org);
  }, [location]);

  return { organizationId };
};
